<template>
  <b-row id="vlCardSmallFirstContainer">
    <b-col cols="8">
      <div class="cardSmallTitle">{{ item.platform_contract.contract.name }} sur {{ item.platform_contract.platform.name }}</div>
      <div class="number">{{ sumAssets(item.securities) }} €</div>
    </b-col>
    <b-col cols="4" style="text-align: right;">
      <img class="checkicon" :src="selected ? require('./checkiconcheck.png') : require('./checkicon.png')" alt="" />
    </b-col>
  </b-row>
</template>
<script>
export default {
  props: ["item"],
  data() {
    return {
      selected: true,
    };
  },
  methods: {
    sumAssets(assets)
    {
      let sum = 0;

      assets.forEach(asset => {
        sum += parseFloat(asset.amount);
      });

      return this.$utils.numberWithSpaces(sum.toFixed(0));
    }
  },
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#vlCardSmallFirstContainer {
  background: #040404 0% 0% no-repeat padding-box;
  border-radius: 20px;
  opacity: 1;
  padding: 15px;
  margin: 5px;

  .cardSmallTitle {
    text-align: left;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $mf_ft_color_white;
    opacity: 1;
  }
  .number {
    text-align: left;
    font: normal normal bold $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: $purple_color;
    opacity: 1;
  }
  .checkicon {
    width: 50px;
  }
}
</style>
